<template lang="html">
  <div>

    <md-layout md-gutter="16">
      
      <md-layout md-flex="100" md-flex-small="100" md-flex-xsmall="100" class="whiteframe">
        <!-- <md-custom-table
          v-if="pedidosReady"
          @TABLE_EDIT="selectPedido"
          :data="pedidos"
          :alta="true"
          :modificar="true"
          :editButton="true"
          :rows="rows"
          :selection="false"/>  -->
          <md-layout md-flex="100">
            <h1>Pedidos STShop</h1>
          </md-layout>
          <md-layout md-flex="100" md-align="center" v-if="pedidos.length === 0" style="border-bottom:1px solid #ccc; margin:10px 0"><h2 style=" margin:10px 0 30px">No se encontraron documentos</h2></md-layout>
          <md-layout v-for="pedido in pedidos" md-flex="100" style="border-bottom:1px solid #ccc; margin:10px 0">
            <md-layout style="font-size:16px; margin-bottom:10px" 
              md-flex-xlarge="20"
              md-flex-large="20"
              md-flex-medium="20"
              md-flex-small="50"
              md-flex-xsmall="50">
              Pedido # {{pedido.FOLIO}}
            </md-layout>

            <md-layout style="font-size:16px; margin-bottom:10px" 
              md-flex-xlarge="20"
              md-flex-large="20"
              md-flex-medium="20"
              md-flex-small="50"
              md-flex-xsmall="50"
              >
              Realizado el dia {{getDate(pedido.fecha)}}
            </md-layout>

            <md-layout style="font-size:16px; margin-bottom:10px" 
              md-flex-xlarge="20"
              md-flex-large="20"
              md-flex-medium="20"
              md-flex-small="50"
              md-flex-xsmall="50">
              Estado: 
              {{pedido.status}}
            </md-layout>

            <md-layout style="font-size:16px; margin-bottom:10px" 
              md-flex-xlarge="20"
              md-flex-large="20"
              md-flex-medium="20"
              md-flex-small="50"
              md-flex-xsmall="50">
              Total: {{toMoney(parseFloat(pedido.TOTAL))}}
            </md-layout>

            <md-layout style="font-size:16px; margin-top: -15px;" 
              md-flex-xlarge="20"
              md-flex-large="20"
              md-flex-medium="20"
              md-flex-small="100"
              md-flex-xsmall="100"
              md-align="end">
              <md-button class="md-accent" @click.native="selectPedido(pedido)" style=" margin-right:25px">Ver detalles</md-button>
            </md-layout>

          </md-layout>
          <md-pagination v-if="pedidosReady" @PAGINATION_GO_PAGE="getPedidos" :pagination="pagination"/>
        
      </md-layout>
    </md-layout>
  </div>
</template>

<script type="text/javascript">
import { toMoney } from '../../common/functions/helpers';
import mdCustomTable from '../../shared-components/table/table'
import mdPagination from '../../shared-components/pagination/pagination'

export default {
  name: 'Pedidos',
  data() {
    return {
      resourcePedido: this.$api.pedido(this.$resource),
      resourceCliente: this.$api.cliente(this.$resource),
      pedidos: [],
      cliente: {},
      cart: [],
      pedidosReady: false,
      pagination: {},
      rows: [
        {
          tittle: 'Folio',
          prop: 'FOLIO'
        },
        {
          tittle: '# Articulos',
          prop: 'partidas'
        },
        {
          tittle: 'Fecha',
          prop: 'fecha',
          type: 'date'
        },
        {
          tittle: 'Total',
          prop: 'TOTAL',
          type: 'money'
        }
      ],
    };
  },
  computed: {
  },
  components: {
    mdCustomTable,
    mdPagination
  },
  methods: {
    getDate (dta) {
      const date = new Date(dta)
      const year = date.getFullYear()
      const month = date.getMonth() + 1 < 10 ? `0${date.getMonth() + 1}` : date.getMonth() + 1
      const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate()
      return `${day}/${month}/${year}`
    },
    selectPedido (row) {
      const idPedido = row.idinterno;
      this.$router.push({ name: 'pedidoForm', params: { idPedido: idPedido } });
    },
    getPedidos () {
      this.pedidosReady = false;
      this.pedidos = null;
      const idCliente = this.cliente.cliente.idinterno;
      this.resourcePedido.getPedidosCliente({ idCliente })
          .then((response) => {
            this.pedidos = response.data.data;
            this.pagination = {
              current_page: response.data.current_page,
              from: response.data.from,
              last_page: response.data.last_page,
              path: response.data.path,
              per_page: response.data.per_page,
              to: response.data.to,
              total: response.data.total
            };
            this.pedidosReady = true;
            
          })
          .catch((err) => {
            this.$error(this, err);
          });
    },
    toMoney,
    goToCatalogo() {
      this.$router.push({ name: 'inicio' });
    },
  },
  mounted() {
    this.cart = window.cart;
    this.cliente = localStorage.getItem('cliente') ? JSON.parse(localStorage.getItem('cliente')) : null;
    if (this.cliente === null){
      this.goToCatalogo();
    }
    this.getPedidos();
  },
};
</script>

<style lang="scss">
.cartItems {
  .md-list-item-container{
    padding-bottom: 10px;
  }
}

.cartImage {
  max-height: 90px;
}
.cartDetails{
  margin-right:5px;
}
.cartTotal{
  font-size:20px;
  opacity: .8;
  margin-left: 5px;
}
.prices {
  text-align: right;
  padding-right: 10px;
  font-size: 20px;
}

.totalLabel{
  font-size: 30px;
  opacity: .7;
  margin-right:5px;
}

.totalData{
  font-size: 30px;
  font-weight: bold;
  opacity: .7;
}

.totales{
  padding:10px;
  text-align: right;
}


</style>



// WEBPACK FOOTER //
// src/spa/pedidos/Pedidos.vue